import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { SidebarCategoriesSelector, SidebarLinkSection } from 'components/blog';

const SidebarContainer = styled.div`
  align-self: flex-start;
  top: 1rem;
  position: sticky;
  position: -webkit-sticky; /* for Safari */
  transition: all 0.5s;
  display: block;
  margin: 0;
  padding: 0 0 1rem 0;
  width: 100%;
  @media (max-width: ${props => props.theme.breakpoints.l}) {
    display: none !important;
  }
`;

const Sidebar = ({ posts, categories, handleSelect }) => (
  <SidebarContainer>
    <SidebarCategoriesSelector
      categories={categories}
      onSelect={handleSelect}
    />
    <SidebarLinkSection
      title='Popular Posts'
      isPostLink
      links={posts.filter(post => post.popularPost)}
    />
  </SidebarContainer>
);

export default Sidebar;

Sidebar.propTypes = {
  posts: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  handleSelect: PropTypes.any
};
